// Campus photo for /colleges/syracuse-university: CC BY-SA 4.0, by Kiran891, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AHall_of_Languages%2C_Syracuse_University_(2024).jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/syracuse-university/; credited under the photo.
const photo = {
    "slug": "syracuse-university",
    "alt": "The Hall of Languages and its clock tower at Syracuse University in Syracuse, New York",
    "src": "/colleges/syracuse-university/campus-1600.webp",
    "srcSmall": "/colleges/syracuse-university/campus-800.webp",
    "srcMid": "/colleges/syracuse-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/syracuse-university/og.jpg",
    "title": "Hall of Languages, Syracuse University (2024)",
    "author": "Kiran891",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AHall_of_Languages%2C_Syracuse_University_(2024).jpg",
    "read": "2026-10-01"
};

export default photo;
